// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409eff","subMenuActiveText":"#bfcbd9","menuBg":"#2d3a4b","menuHover":"#2d3a4b","subMenuBg":"#2d3a4b","subMenuHover":"#2d3a4b","sideBarWidth":"180px","navBg":"#fff","navText":"#5a5e66","bg":"#2d3a4b","lgtext":"#fff"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 79